import { FormControl, FormGroup, Validators } from '@angular/forms';

export interface TranslationItem {
    id: number;
    value: string;
    target: TranslationTarget;
    author: string;
    targetId: string;
    editors?: string[];
    dateCreated: string;
    dateUpdated: string;
    /** ISO 639-1 code of the AI-detected source language; absent/`en` means English. */
    detectedLanguage?: string;
}

export enum TranslationTarget {
    conversationMessage = 'ConversationMessage',
}

export const createTranslationItemForm = () =>
    new FormGroup({
        value: new FormControl<string>(
            { disabled: false, value: '' },
            { validators: [Validators.required], nonNullable: true }
        ),
        target: new FormControl<TranslationTarget>(
            { disabled: false, value: TranslationTarget.conversationMessage },
            { validators: [Validators.required], nonNullable: true }
        ),
        targetId: new FormControl(
            { disabled: true, value: '' },
            {
                nonNullable: true,
            }
        ),
        plainValue: new FormControl({ disabled: true, value: '' }),
    });

export type TranslationItemEditModel = ReturnType<typeof createTranslationItemForm>['value'];
